import React,{useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link } from 'react-router-dom';
import { Helmet } from "react-helmet-async";   // ✅ ADD THIS
import { useAuth } from './context/AuthContext';
import { PWAProvider } from './context/PWAContext';
import { ThemeProvider } from './context/ThemeContext';
import { ScrollMemoryProvider } from './context/ScrollMemoryContext';
import SwipeNavigation from './components/common/SwipeNavigation';

import PublicLayout from './components/layouts/PublicLayout';
import AdminLayout, { AdminProtectedRoute } from './pages/admin/AdminLayout';
import PWAInstallPrompt from './components/common/PWAInstallPrompt';
import OfflineBanner from './components/common/OfflineBanner';

// --- Page Components ---
import HomePage from './pages/HomePage';
import NewHomePage from './pages/NewHomePage'; // NEW HOME PAGE
import AuditionDetailPage from './pages/AuditionDetailPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import DashboardEntryPoint from './pages/dashboard/DashboardEntryPoint';
import HowItWorks from './pages/HowItWorks';
import Pricing from './pages/Pricing';
import BrowseRoles from './pages/BrowseRoles';
import AboutUs from './pages/AboutUs';
import FAQ from './pages/FAQ';
import BannerSlider from './components/BannerSlider';
import ContactUs from './pages/ContactUs';
import Terms from './pages/Terms';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CastingPage from './pages/CastingPage';
import WorkshopsPage from './pages/WorkshopsPage';
import AIStudioPage from './pages/AIStudioPage';
import SuccessStoriesPage from './pages/SuccessStoriesPage';
import CareersPage from './pages/CareersPage';
import BlogPage from './pages/BlogPage';
import PressPage from './pages/PressPage';
import TrustSafetyPage from './pages/TrustSafetyPage';
import NoScamPolicyPage from './pages/NoScamPolicyPage';
import RefundPolicyPage from './pages/RefundPolicyPage';
import CookiePolicyPage from './pages/CookiePolicyPage';

// --- Admin Components ---
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminUsersList from './pages/admin/AdminUsersList';
import AdminProjectList from './pages/admin/AdminProjectList';
import AdminRoleList from './pages/admin/AdminRoleList';
import AdminLookupPage from './pages/admin/AdminLookupPage';
import PostProjectsPage from './pages/projects/PostProjectsPage';
import AddEditRolePage from './pages/roles/AddEditRolePage';
import NotificationTemplates from './pages/admin/NotificationTemplates';
import AdminContactSubmissions from './pages/admin/AdminContactSubmissions';
import AdminAuditionsList from './pages/admin/AdminAudtionsList';
import ManageApplicationDetails from './pages/roles/ManageApplicationDetails';
import AdminNotificationLogs from './pages/admin/AdminNotificationLogs';
import AdminCostPage from './pages/admin/AdminCostPage';
import CouponRedeem from './pages/admin/CouponRedeem';
import AdminTestimonials from './pages/admin/AdminTestimonials';
import MyProfilePage from './pages/dashboard/talent/MyProfilePage';
import CandidateProfile  from './pages/dashboard/talent/CandidateProfile';
import DirectorProfilePage from './pages/dashboard/directorproducer/DirectorProfilePage';
import CastingDirectorProfilePage from './pages/dashboard/castingdirector/CastingDirectorProfilePage';
import CastingDirectorProfile from './components/audition-booking-wizard/CastingDirectorProfile';
import CastingDirectorCard from './components/audition-booking-wizard/CastingDirectorCard';
import PaymentGatewayConfig from './pages/admin/PaymentGatewayConfig';
import AdminPaymentLogs from './pages/admin/AdminPaymentLogs';
import MeetingPage from './pages/MeetingPage';
import MigrationPage from './pages/admin/MigrationPage';
import AdminPaymentDetails from './pages/admin/AdminPaymentDetails';
import AdminManualApproval from './pages/admin/AdminManualApproval';
import WebhookLogs from './pages/admin/WebhookLogs';
import AdminPaymentReconciliation  from './pages/admin/AdminPaymentReconciliation';
import PaymentCallback from './pages/PaymentCallback';
import UserActivityLogs from './pages/admin/logs/UserActivityLogs';
import AdminLeadsList from './pages/admin/AdminLeadsList';
import AccountantSettlementPage from './pages/admin/AccountantSettlementPage';
import CastingDirectorBankSetup from './pages/admin/CastingDirectorBankSetup';
import CastingDirectorSettlements from './pages/admin/CastingDirectorSettlements';
import PaymentMasterPage from './pages/admin/PaymentMasterPage';
import AdminFinancePage from './pages/admin/AdminFinancePage';


import './App.css';
import './styles/mobile-app.css';
import CapacitorAppHandler from './components/common/CapacitorAppHandler';
import { User } from 'lucide-react';
// --- Protected Route Component ---
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading: authLoading } = useAuth();
  if (authLoading) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><p>Loading application state...</p></div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
};

const AppContent = () => {
   const { isAuthenticated } = useAuth();

  //  useEffect(() => {
  //   const token = localStorage.getItem('authToken');
  //   if (token || isAuthenticated) {
  //     document.body.style.paddingTop = '76px';
  //   } else {
  //     document.body.style.paddingTop = '0px';
  //   }
  // }, [isAuthenticated]);
    useEffect(() => {
    const adminToken = localStorage.getItem('adminToken');
    
    if (adminToken) {
      document.body.style.paddingTop = '0px';
    } else {
      document.body.style.paddingTop = '63px';
    }
  }, [isAuthenticated]);
  return (
    <>
    
      {/* <Helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&display=swap"
          rel="stylesheet"
        />
      </Helmet> */}
      <Helmet defaultTitle="BookMyAudition | Acting Auditions & Casting India" titleTemplate="%s | BookMyAudition" >
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link href="https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&family=Inter:wght@300;400;500;600;700;800&display=swap" rel="stylesheet" />
        
        {/* Global Meta Tags */}
        <meta name="application-name" content="BookMyAudition" />
        <meta name="description" content="India's #1 acting auditions platform for Bollywood, TV serials, and web series." />
      </Helmet>
      <OfflineBanner />
      <PWAInstallPrompt /> {/* <--- ADD IT HERE SO IT OVERLAYS THE APP */}
      <main id="main-content" role="main">
      <Routes>
        
        {/* 🔴 STANDALONE ROUTES (Pages that manage their own layouts/headers) */}
        
        {/* 🟢 PUBLIC LAYOUT ROUTES (Automatically get Header & Footer) */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<NewHomePage />} />
          <Route path="/home-backup" element={<HomePage />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/roles" element={<BrowseRoles />} />
          <Route path="/castings" element={<CastingPage />} />
          <Route path="/workshops" element={<WorkshopsPage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/audition/:id/:urlSlug" element={<AuditionDetailPage />} />
          <Route path="/banner-slider" element={<BannerSlider />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/ai-studio" element={<AIStudioPage />} />
          <Route path="/success-stories" element={<SuccessStoriesPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/press" element={<PressPage />} />
          <Route path="/trust-safety" element={<TrustSafetyPage />} />
          <Route path="/no-scam" element={<NoScamPolicyPage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />

          
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="casting-director-profile/:id" element={<CastingDirectorProfile />} />
            <Route path="casting-director-card" element={<CastingDirectorCard />} />
            <Route path="/meeting/:roomName" element={<MeetingPage />} />
             <Route path="/payment-callback" element={<PaymentCallback />} />
             

        </Route>

 {/* <Route
  path="/director-profile"
  element={<PublicCastingDirectorProfile />}
/> */}
        {/* 🔵 USER DASHBOARD (Assuming DashboardEntryPoint has its own Sidebar Layout) */}
        <Route path="/dashboard/*" element={<ProtectedRoute><DashboardEntryPoint /></ProtectedRoute>} />

        {/* 🟣 ADMIN ROUTES */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminProtectedRoute><AdminLayout /></AdminProtectedRoute>}>
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="candidates" element={<AdminUsersList roleCode="300" title="Candidate Management" />} />
          <Route path="directors" element={<AdminUsersList roleCode="200" title="Director & Producer Management" />} />
          <Route path="casting-directors" element={<AdminUsersList roleCode="400" title="Casting Director Management" />} />
          {/* <Route path="/profile" element={<CastingDirectorProfilePage />} /> */}
          {/* <Route path="/profile" element={<DirectorProfilePage />} /> */}
          <Route path="projects" element={<AdminProjectList roleCode="400" title="Project Management" />} />
          <Route path="roles" element={<AdminRoleList roleCode="400" title="Role Management" />} />
          <Route path="lookups" element={<AdminLookupPage />} />
          <Route path="post-projects" element={<PostProjectsPage />} />
          <Route path="post-projects/:projectId" element={<PostProjectsPage />} /> 
          <Route path="post-roles" element={<AddEditRolePage />} />
          <Route path="post-roles/:id" element={<AddEditRolePage />} /> 
          <Route path="notifications" element={<NotificationTemplates />} />
          <Route path="contact-list" element={<AdminContactSubmissions />} />
          <Route path="audition-list" element={<AdminAuditionsList />} />
          <Route path="manage-applications/:id" element={<ManageApplicationDetails />} />
          <Route path="notification-logs" element={<AdminNotificationLogs />} />
          <Route path="cost-page" element={<AdminCostPage />} />
          <Route path="coupon-redeem" element={<CouponRedeem />} />
          <Route path="testimonial" element={<AdminTestimonials />} />
          <Route path="candidate-profile/add" element={<MyProfilePage />} />
          <Route path="candidate-profile/:id" element={<CandidateProfile  />} />
          <Route path="director-profile/add" element={<DirectorProfilePage />} />
          <Route path="director-profile/:id" element={<DirectorProfilePage />} />
          <Route path="casting-profile/add" element={<CastingDirectorProfilePage />} />
          <Route path="casting-profile/:id" element={<CastingDirectorProfilePage />} />
          <Route path="/admin/payment-gateway" element={<PaymentGatewayConfig />} />
          <Route path="/admin/payment-logs" element={<AdminPaymentLogs />} />
          <Route path="migration" element={<MigrationPage />} />
          <Route path="/admin/payment-logs/:logId" element={<AdminPaymentDetails />} />
          <Route path="/admin/payment-logs/:logId/approve" element={<AdminManualApproval />} />
          <Route path="/admin/webhook-logs" element={<WebhookLogs />} />
          <Route path="payment-reconciliation" element={<AdminPaymentReconciliation />} />
          <Route path="user-activity-logs" element={<UserActivityLogs />} />
          <Route path="leads" element={<AdminLeadsList />} />                 
          <Route path="/admin/settlement" element={<AccountantSettlementPage />} />
          <Route path="/admin/bank-setup" element={<PaymentMasterPage />} />
          <Route path="/admin/my-settlements" element={<CastingDirectorSettlements />} />
          <Route path="finance" element={<AdminFinancePage />} />


         

         
        </Route>

        {/* 404 Route */}
        <Route path="*" element={
          <div style={{ padding: "2rem", textAlign: "center", minHeight: '70vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            {/* <h2>404 - Page Not Found</h2> */}
            <Helmet>
              <title>404 - Page Not Found</title>
              <meta name="robots" content="noindex, follow" /> 
            </Helmet>
            <h2>Oops! Page Not Found</h2>
            <Link to="/" className="btn btn-primary mt-3">Go to Homepage</Link>
          </div>
        } />
      </Routes>
      </main>
    </>
  );
};

function App() {
  return (
    <Router>
      <CapacitorAppHandler />
      <ThemeProvider>
        <PWAProvider> {/* ✅ WRAP APP WITH PROVIDER */}
          <ScrollMemoryProvider>
            <SwipeNavigation>
              <AppContent />
            </SwipeNavigation>
          </ScrollMemoryProvider>
        </PWAProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;